import React from "react";
import HanshiLogo from "../../../assets/hanshi/full-sm.svg";
import Style from "./AuthLoadingScreen.module.css";

const AuthLoadingScreen = () => {
  return (
    <div className={Style.overlay}>
      <img src={HanshiLogo} alt="Hanshi" className={Style.logo} />
      <div className={Style.spinner} />
    </div>
  );
};

export default AuthLoadingScreen;
